import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { Data } from '../signup-data/DATA';
import { useSignupData } from '../signup-data/useSignupData';

const MessagingCopy = ({
  className,
  message
}) => {
  const {
    data: industry
  } = useSignupData(Data.Industry);
  const industryI18nLabel = industry && industry.toLowerCase().split('-').map(word => word ? word[0].toUpperCase() + word.slice(1) : '').join('');
  const messageWithUserIndustry = `${message}WithUserIndustry.${industryI18nLabel}`;
  const hasIndustryDynamicCopy = isValidI18nKey(messageWithUserIndustry);

  if (!isValidI18nKey(message)) {
    return null;
  }

  return /*#__PURE__*/_jsx(FormattedMessage, {
    className: className,
    message: hasIndustryDynamicCopy ? messageWithUserIndustry : message
  });
};

export default MessagingCopy;